import { DisconnectReason } from 'livekit-client';

/** LiveKit disconnect reason enum name for log breadcrumbs. */
export function disconnectReasonName(reason?: DisconnectReason): string {
  if (reason === undefined) {
    return 'UNKNOWN_REASON';
  }
  const direct = DisconnectReason[reason as number];
  if (typeof direct === 'string') {
    return direct;
  }
  const entry = Object.entries(DisconnectReason).find(
    ([, value]) => typeof value === 'number' && value === reason,
  );
  return entry?.[0] ?? 'UNKNOWN_REASON';
}

export type LiveKitDisconnectAction = 'reconnect' | 'stop' | 'open_elsewhere';

export function liveKitDisconnectAction(
  reason: DisconnectReason | undefined,
  hasOpenElsewhereContext: boolean,
): LiveKitDisconnectAction {
  if (hasOpenElsewhereContext && reason === DisconnectReason.DUPLICATE_IDENTITY) {
    return 'open_elsewhere';
  }
  if (
    reason === DisconnectReason.ROOM_DELETED
    || reason === DisconnectReason.PARTICIPANT_REMOVED
  ) {
    return 'stop';
  }
  return 'reconnect';
}
